export const UPDATE = "announcements/UPDATE";
export const UPDATE_ONE = "announcements/UPDATE_ONE";
export const APPEND = "announcements/APPEND";
export const EMPTY = "announcements/EMPTY";
export const LOADING = "announcements/LOADING";
